import { useDispatch, useSelector } from "react-redux";
import CommonCategory from "../../components/common/common.category";
import CommonFeature from "../../components/common/common.feature";
import HomeFaq from "./components/home.faq";
import HomeHero from "./components/home.hero";
import HomeProduct from "./components/home.product";
import { useEffect } from "react";
import { getCategoryList } from "../../redux/reducer/common.reducer";

export default function Home() {
  return (
    <article className="home">
      <HomeHero />
      <CommonCategory />
      <HomeProduct />
      <CommonFeature />
      <HomeFaq />
    </article>
  );
}
